/* URSA product page top (URSA custom). Slim tools bar open/close, and a tidier product description. */
(function () {
  'use strict';
  /* ----- Product tools bar: closed by default, tap a pill to open, tap again to close ----- */
  var root = document.getElementById('ursa-product-tools');
  if (root) {
    root.classList.add('is-closed');
    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('#ursa-product-tools .upt-tab');
      if (!tab) return;
      var closed = root.classList.contains('is-closed');
      if (!closed && tab.classList.contains('is-on')) {
        root.classList.add('is-closed');
        e.stopImmediatePropagation();
        e.preventDefault();
        return;
      }
      root.classList.remove('is-closed');
      root.classList.remove('anim');
      void root.offsetWidth;
      root.classList.add('anim');
    }, true);
  }

  /* ----- Description: keep tagline and benefits, fold the rest into a details block ----- */
  function clean(el) { return (el.textContent || '').replace(/\s+/g, ' ').replace(/ /g, ' ').trim(); }
  function enhance() {
    var rte = document.querySelector('.product-details rte-formatter');
    if (!rte || rte.querySelector('.ursa-more') || rte.dataset.ursaOff) return;
    var ul = rte.querySelector(':scope > ul');
    if (!ul) return;
    ul.querySelectorAll(':scope > li').forEach(function (li) {
      var s = li.querySelector('strong');
      if (s && /^available in/i.test(clean(s))) li.classList.add('ursa-li-wide');
    });
    var rest = [], n = ul.nextElementSibling;
    while (n) { if (clean(n) || n.querySelector('img,iframe,video')) rest.push(n); n = n.nextElementSibling; }
    if (!rest.length) return;
    var details = document.createElement('details');
    details.className = 'ursa-more';
    var summary = document.createElement('summary');
    var first = rest[0], label = 'More details', done = false;
    var raw = first.innerHTML || '';
    if (first.tagName === 'P' && raw.indexOf('✔') > -1) {
      var parts = raw.split('✔');
      var head = document.createElement('div');
      head.innerHTML = parts[0];
      var ht = clean(head).replace(/:\s*$/, '');
      if (ht) label = /ideal for/i.test(ht) ? 'Ideal for' : (ht.length <= 40 ? ht : 'More details');
      var list = document.createElement('ul');
      list.className = 'ursa-ideal';
      parts.slice(1).forEach(function (chunk) {
        var tmp = document.createElement('div');
        tmp.innerHTML = chunk;
        tmp.querySelectorAll('br').forEach(function (b) { b.remove(); });
        var html = tmp.innerHTML.replace(/<\/?span[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
        if (!html) return;
        var li = document.createElement('li');
        li.innerHTML = html;
        list.appendChild(li);
      });
      if (list.children.length) { details.appendChild(summary); details.appendChild(list); done = true; first.remove(); rest.shift(); }
    }
    if (!done) {
      var t = clean(first).replace(/:\s*$/, '');
      if (first.tagName === 'P' && t && t.length <= 40) { label = t; first.remove(); rest.shift(); }
      details.appendChild(summary);
    }
    summary.textContent = label;
    rest.forEach(function (el) { details.appendChild(el); });
    rte.appendChild(details);
  }
  enhance();
  /* the theme re-renders parts of the page when a variant changes, so re-apply if needed */
  var pd = document.querySelector('.product-details');
  if (pd && window.MutationObserver) {
    var tm;
    new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(enhance, 150); }).observe(pd, { childList: true, subtree: true });
  }
})();
